import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserProfile } from '../../lib/classes/userProfile';
import { User } from '../../lib/classes/user';
import { Employment } from '../../lib/classes/employment';
import { RequestService } from '../../lib/services';
import { EmploymentInvite } from '../../lib/classes/invite';
import { Page } from '../../lib/classes/page';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { Unit } from '../../settings-module/models/unit';
import { tap } from 'rxjs/operators';

@Injectable()
export class EmploymentService {
  constructor(
    private http: HttpClient,
    private requestService: RequestService,
    private store: Store<fromRoot.State>
  ) {}

  private _companyApiEndpoint = environment.apiUrl + 'units/'; // URL to web api

  public createEmploymentForInvite(
    unit_id: number,
    position: string,
    user: User,
    company_id: number
  ) {
    user.user_profile = <UserProfile>{};
    const body = JSON.stringify({
      employment: {
        unit: unit_id,
        company: String(company_id),
        position: position,
        user: String(user.id),
      },
    });

    return this.http.post<Employment>(
      this._companyApiEndpoint + unit_id + '/employments/',
      body
    );
  }

  public getCompanyEmployments(unit_id: number) {
    return this.http.get<Page<Employment>>(
      this._companyApiEndpoint + unit_id + '/employments/'
    );
  }

  public getUnit(id: number) {
    return this.requestService
      .request<Unit>('GET', this._companyApiEndpoint + id + '/', 'unit')
      .pipe(
        tap(res => {
          (<any>window).dataLayer.push({
            unitName: res.name,
          });
        })
      );
  }

  public getCompanyEmploymentById(company_id: number, employment_id: number) {
    // tslint:disable-next-line:max-line-length
    return this.http.get<Employment>(
      this._companyApiEndpoint +
        company_id +
        '/employments/' +
        employment_id +
        '/'
    );
  }

  public getCompanyEmploymentPendingInvite(unit_id: number) {
    return this.http.get<EmploymentInvite[]>(
      this._companyApiEndpoint + unit_id + '/invitations/'
    );
  }

  public deleteEmploymentInviteById(unit_id: number, invite_id: number) {
    return this.http.delete(
      this._companyApiEndpoint + unit_id + '/invitations/' + invite_id + '/'
    );
  }

  public deleteEmployment(company_id: number, employment_id: number) {
    return this.http.delete(
      this._companyApiEndpoint +
        company_id +
        '/employments/' +
        employment_id +
        '/'
    );
  }

  public updateEmployment(employment) {
    const body = JSON.stringify(employment);
    return (
      this.http
        // tslint:disable-next-line:max-line-length
        .put<Employment>(
          this._companyApiEndpoint +
            employment.unit +
            '/employments/' +
            employment.id +
            '/',
          body
        )
    );
  }

  public moveEmployment(
    old_unit_id: number,
    new_unit_id: number,
    employment_id: number
  ) {
    return this.http.put<Employment>(
      this._companyApiEndpoint +
        old_unit_id +
        '/employments/' +
        employment_id +
        '/move-to-unit/' +
        new_unit_id +
        '/',
      {}
    );
  }

  public getUserEmployments(pagination?) {
    // TODO remove page size when dropdown is able to handle pagination
    const url =
      pagination && pagination.next
        ? pagination.next.replace(/^http:\/\//i, 'https://')
        : this._companyApiEndpoint +
          'current-user/employed-units/?page_size=200';
    return this.http.get<Page<any>>(url);
  }
}
